var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8794 21.1162C12.0464 21.1162 12.2783 21.0327 12.4917 20.9214C17.687 18.0454 19.3291 16.8301 19.3291 13.6758V6.68994C19.3291 5.70654 18.9673 5.38184 18.123 5.04785C16.8057 4.51904 13.9204 3.44287 12.6123 2.99756C12.3711 2.91406 12.1299 2.8584 11.8794 2.8584C11.6289 2.8584 11.397 2.91406 11.1465 2.99756C9.83838 3.45215 6.95312 4.52832 5.64502 5.04785C4.7915 5.37256 4.43896 5.70654 4.43896 6.68994V13.6758C4.43896 16.8301 6.15527 17.9155 11.2671 20.9214C11.4805 21.042 11.7124 21.1162 11.8794 21.1162ZM10.8589 16.0879C10.6177 16.0879 10.4321 15.9858 10.2373 15.7446L7.72314 12.7295C7.61182 12.5811 7.54688 12.4141 7.54688 12.2563C7.54688 11.9316 7.79736 11.6719 8.12207 11.6719C8.32617 11.6719 8.48389 11.7368 8.65088 11.9688L10.8311 14.6406L15.0986 7.88672C15.2285 7.67334 15.4233 7.56201 15.6089 7.56201C15.9243 7.56201 16.2119 7.78467 16.2119 8.10938C16.2119 8.26709 16.1284 8.43408 16.0449 8.57324L11.4526 15.7446C11.3042 15.9673 11.1094 16.0879 10.8589 16.0879Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldfill);
export default __webpack_public_path__ + "static/media/Shield fill.2a361a605f666de1b4234db947dc51c2.svg";
export { ForwardRef as ReactComponent };